import { render, staticRenderFns } from "./Briefcase.vue?vue&type=template&id=4069a742&"
import script from "./Briefcase.vue?vue&type=script&lang=js&"
export * from "./Briefcase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports